import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUp = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" stroke="currentColor" d="M10 7L5 12.263L5.7 13L10 8.474L14.3 13L15 12.263L10 7Z" /></svg>;
const ForwardRef = forwardRef(SvgChevronUp);
export { ForwardRef as ReactComponent };